import * as Yup from "yup";

export const validationSchema = Yup.object({
  category_id: Yup.string().required("Category is required!"),
  name: Yup.string().required(" Sub category name is required!"),
  is_active: Yup.string().required("Status is required!"),
});
